var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.pageLoading),expression:"pageLoading"}],staticClass:"pageLoaing"},[_c('van-loading',{staticClass:"spinner",attrs:{"size":"24px","color":"#ff6538","type":"spinner"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }